import { defineMessages } from 'react-intl';

export default defineMessages({
	externalLinksSectionHeader: {
		id: 'cv.external-links.section.header',
		defaultMessage: 'Related resources',
		description:
			'The text is shown as a section heading above the list of related external resource links on a help center portal page.',
	},
	externalLinksSectionShowMore: {
		id: 'cv.external-links.section.show-more',
		defaultMessage: 'Show all',
		description: 'Label for the external links Show all button',
	},
	externalLinksSectionShowLess: {
		id: 'cv.external-links.section.show-less',
		defaultMessage: 'Show fewer',
		description: 'Label for the external links Show all button',
	},
});
